/*
* 账户信息组件
* zxw
* 创建时间：
* 修改时间：2026-08-12
*/

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import {
    theme,
    Flex,
    message,
    Table,
    Input,
    Select,
    Button,
    Modal,
    Space,
} from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    winWidth,
    Html2pdf,
    DateFormat,
    GetDropdownActionName,
    BrandUrl,
    SloganUrl,
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import Entity from './UserInfoEntity.js';

const MODULENAME = CNF.navItems[1].submenu[1].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[1].submenu[1].ptn;
const MODULENAME_URL = CNF.navItems[1].submenu[1].url;

/**
 * 用户信息
 * @param {*} props 
 * @returns 
 */
const UserInfoModal = (props) => {
    const cancel = () => { props.setOpen(false); };
    const printer = () => {
        var printContents = document.getElementById('user-info-id').innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload();
    };
    const download = () => { Html2pdf('user-info-id', props.record.number, ''); };

    return (
        <>
            <Modal
                width={820}
                style={{ top: 0 }}
                // title={props.record.name}
                closable={false}
                open={props.open}
                keyboard={true}
                onCancel={cancel}
                footer={[
                    <Button key='back' onClick={cancel}>取消</Button>,
                    <Button key='printer' type='primary' onClick={printer}>打印</Button>,
                    <Button key='link' type='primary' onClick={download}>下载</Button>,
                ]}
            >
                <div id='print-info-id'>
                    <div className='print-info' style={{ padding: '0 30px' }}>
                        <Flex justify='space-between' style={{ margin: '10px' }}>
                            <img src={BrandUrl} height='35px' alt={CNF.companyShortName} />
                            <img src={SloganUrl} height='35px' alt={CNF.companyShortName} />
                        </Flex>
                        <table width='100%'>
                            <thead align='center'>
                                <tr>
                                    <th colSpan='24'><h2>员工信息表</h2></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td colSpan='5' style={{ width: 120 }}>姓名:</td><td colSpan='8' style={{ width: 220 }}>{props.record.displayname}</td>
                                    <td colSpan='3' style={{ width: 120 }}>性别:</td><td colSpan='8' style={{ width: 240 }}>{props.record.sex}</td>
                                </tr>
                                <tr>
                                    <td colSpan='5' style={{ width: 120 }}>手机:</td><td colSpan='8' style={{ width: 220 }}>{props.record.phone}</td>
                                    <td colSpan='3' style={{ width: 120 }}>邮箱:</td><td colSpan='8' style={{ width: 240 }}>{props.record.email}</td>
                                </tr>
                                <tr>
                                    <td colSpan='5' style={{ width: 120 }}>学历:</td><td colSpan='8' style={{ width: 220 }}>{props.record.edu_background}</td>
                                    <td colSpan='3' style={{ width: 120 }}>能力类型:</td><td colSpan='8' style={{ width: 240 }}>{props.record.ability_type}</td>
                                </tr>
                                <tr>
                                    <td colSpan='5' style={{ width: 140 }}>出生日期:</td><td colSpan='8' style={{ width: 220 }}>{props.record.birth_date}</td>
                                    <td colSpan='3' style={{ width: 120 }}>身份证号:</td><td colSpan='8' style={{ width: 240 }}>{props.record.idcard}</td>
                                </tr>
                                <tr>
                                    <td colSpan='5' style={{ width: 120 }}>入职日期:</td><td colSpan='8' style={{ width: 220 }}>{props.record.entry_date}</td>
                                    <td colSpan='3' style={{ width: 140 }}>员工编号:</td><td colSpan='8' style={{ width: 240 }}>{props.record.number}</td>
                                </tr>
                                <tr>
                                    <td colSpan='5' style={{ width: 120 }}>部门:</td><td colSpan='8' style={{ width: 220 }}>{props.record.department}</td>
                                    <td colSpan='3' style={{ width: 140 }}>岗位:</td><td colSpan='8' style={{ width: 240 }}>{props.record.job}</td>
                                </tr>
                                <tr><td colSpan='5' style={{ width: 120 }}>公司:</td><td colSpan='19' style={{ width: 600 }}>{props.record.company}</td></tr>
                                <tr><td colSpan='5' style={{ width: 120 }}>住址:</td><td colSpan='19' style={{ width: 600 }}>{props.record.address}</td></tr>
                                <tr><td colSpan='5' style={{ width: 120 }}>备注:</td><td colSpan='19' style={{ width: 600 }}>
                                    {props.record.description && props.record.description.split('\n').map((item) => {
                                        return <p style={{ margin: 0 }}>{item}</p>;
                                    })}
                                </td></tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal>
        </>
    );
};

const Lists = (props) => {
    const { btnLists, dataLists, currentIndex, pageCount, changeIndex, preGroup, setOpen } = props;

    const {
        token: {
            pageSize,

        },
    } = theme.useToken();

    const update = useCallback((record) => {
        setOpen(true, record);
    }, [setOpen]);

    const [record, setRecord] = useState(null);
    const [userInfoModalOpen, setUserInfoModalOpen] = useState(false);

    const hangdleUserInfoModalOpen = useCallback((value) => {
        setUserInfoModalOpen(value);
    }, []);

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = useCallback((action, record) => {
        switch (action) {
            case CNF.actionName.UPDATE:
                update(record);
                break;
            default:
                break;
        }
    }, [update]);

    /**
     * 显示员工信息
     * @param {*} record 
     */
    const showUserInfoModal = useCallback((record) => {
        setRecord(record);
        setUserInfoModalOpen(true);
    }, []);

    const hasOpPerm = (
        btnLists.indexOf(MODULENAME_PTN + '_update') > 0
    );

    const columns = useMemo(() => [
        { title: '', width: 20, dataIndex: '', key: 'key', fixed: 'left', },
        {
            title: '姓名', key: 'displayname', width: 100, fixed: 'left',
            render: (record) => <Button
                color='primary'
                variant='link'
                style={{ padding: 0, border: 0, height: 22 }}
                onClick={() => { showUserInfoModal(record); }}>{record.displayname}</Button>
        },
        { title: '电话', dataIndex: 'phone', key: 'phone', width: 130, },
        { title: '邮箱', dataIndex: 'email', key: 'email', width: 250, },
        {
            title: '身份证', key: 'idcard', width: 200,
            render: (record) => record.idcard ? record.idcard : '-'
        },
        {
            title: '性别', key: 'sex', width: 80,
            render: (record) => record.sex ? record.sex : '-'
        },
        {
            title: '出生日期', key: 'birth_date', width: 100,
            render: (record) => record.birth_date ? record.birth_date : '-'
        },
        {
            title: '年龄', key: 'age', width: 80,
            render: (record) => record.age ? record.age : '-'
        },
        {
            title: '能力类型', key: 'ability_type', width: 100,
            render: (record) => record.ability_type ? record.ability_type : '-'
        },
        {
            title: '学历', key: 'edu_background', width: 120,
            render: (record) => record.edu_background ? record.edu_background : '-'
        },
        {
            title: '部门', key: 'department', width: 150,
            render: (record) => record.department ? record.department : '-'
        },
        {
            title: '岗位', key: 'job', width: 180,
            render: (record) => record.job ? record.job : '-'
        },
        {
            title: '公司', key: 'company', width: 300,
            render: (record) => record.company ? record.company : '-'
        },
        {
            title: '入职时间', key: 'entry_date', width: 100,
            render: (record) => record.entry_date ? record.entry_date : '-'
        },
        {
            title: '住址', key: 'address', width: 400,
            render: (record) => record.address ? record.address : '-'
        },
        {
            title: '员工编号', key: 'number', width: 120,
            render: (record) => record.number ? record.number : '-'
        },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: 100, },
        { title: '状态', dataIndex: 'status', key: 'status', fixed: 'right', width: CNF.tableStatusColumnWidth, },
        {
            title: '', key: 'operation', width: CNF.tableOperationColumnWidth, fixed: 'right', hidden: !hasOpPerm,
            render: (record) => GetDropdownActionName(btnLists, MODULENAME_PTN, record, operation)
        }
    ], [btnLists, hasOpPerm, operation, showUserInfoModal]);
    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={dataLists}
                scroll={{ x: winWidth }}
                pagination={{
                    showSizeChanger: false,
                    showQuickJumper: false,
                    showTotal: () => `共${pageCount}条`,
                    pageSize: pageSize,
                    current: currentIndex,
                    total: pageCount,
                    onShowSizeChange: (current, pageSize) => props?.changePageSize(pageSize, current),
                    onChange: (current) => changeIndex(current),
                }}
            />
            {record && <UserInfoModal
                preGroup={preGroup}
                open={userInfoModalOpen}
                setOpen={hangdleUserInfoModalOpen}
                record={record}
            />
            }
        </>
    );
}

const UserInfo = (props) => {
    const { btnLists, preGroup } = props;

    const { token: { pageSize, }, } = theme.useToken();

    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [triggerRefresh, setTriggerRefresh] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);
    const [record, setRecord] = useState(null);
    const [open, setOpen] = useState(false);
    const [status, setStatus] = useState(CNF.status[0].value);
    const refresh = useCallback(() => {
        setTriggerRefresh((prev) => prev + 1);
    }, []);

    const [orgInfosLists, setOrgInfosLists] = useState([]);
    const [orgStructuresLists, setOrgStructuresLists] = useState([]);

    const [displayname, setDisplayname] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [orgInfoULID, setOrgInfoULID] = useState('');
    const [sid, setSID] = useState('');
    const [orgStructureOrgULID, setOrgStructureOrgULID] = useState('');
    const [orgStructureJobULID, setOrgStructureJobULID] = useState('');
    const [abilityType, setAbilityType] = useState('');
    const [eduBackground, setEduBackground] = useState('');

    const changeIndex = useCallback((index) => {
        setCurrentIndex(index);
    }, []);

    const handleStatusChange = useCallback((value) => {
        setStatus(value || '');
        setCurrentIndex(1);
    }, []);

    const handleDisplaynameChange = useCallback((e) => {
        setDisplayname(e.target.value);
        setCurrentIndex(1);
    }, []);

    const handlePhoneChange = useCallback((e) => {
        setPhone(e.target.value);
        setCurrentIndex(1);
    }, []);

    const handleEmailChange = useCallback((e) => {
        setEmail(e.target.value);
        setCurrentIndex(1);
    }, []);

    const handleOrgInfoULIDChange = useCallback((value) => {
        setOrgInfoULID(value);
        setCurrentIndex(1);
    }, []);

    const handleOrgStructureOrgULIDChange = useCallback((value, option) => {
        setSID(option?.sid || '');
        setOrgStructureOrgULID(value || '');
        setCurrentIndex(1);
    }, []);

    const handleOrgStructureJobULIDChange = useCallback((value) => {
        setOrgStructureJobULID(value);
        setCurrentIndex(1);
    }, []);

    const handleAbilityTypeChange = useCallback((value) => {
        setAbilityType(value);
        setCurrentIndex(1);
    }, []);

    const handleEduBackgroundChange = useCallback((value) => {
        setEduBackground(value);
        setCurrentIndex(1);
    }, []);

    const setOpenModal = useCallback((value, record) => {
        setOpen(value);
        setRecord(record || null);
    }, []);

    useEffect(() => {
        /**
         * 获取组织信息下拉列表
         */
        const getOrgInfoLists = () => {
            $.ajax({
                url: `${CNF.api}orgs/infos?rss=list`,
                headers: AddRequestHeaders(),
                type: 'GET',
                dataType: 'JSON', success: function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            setOrgInfosLists(data.dat);
                            setOrgInfoULID(data.dat[0].key); // 默认选中第一个公司
                        } else {
                            setOrgInfosLists([]);
                        }
                    }
                }
            })
        }
        getOrgInfoLists();
    }, []);

    useEffect(() => {
        /**
         * 获取上级组织架构下拉列表
         */
        const getOrgStructuresLists = () => {
            const params = {
                rss: 'list',
                org_info_ulid: orgInfoULID,
                status: CNF.status[0].value,
            };
            $.ajax({
                url: `${CNF.api}orgs/structures${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET',
                dataType: 'JSON', success: function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            setOrgStructuresLists(data.dat);
                        } else {
                            setOrgStructuresLists([]);
                        }
                    }
                }
            })
        }
        if (orgInfoULID) {
            getOrgStructuresLists();
        }
    }, [orgInfoULID]);

    useEffect(() => {
        setLoading(true);

        let params = {
            page_size: pageSize,
            current_index: currentIndex,
            status,
            displayname,
            phone,
            email,
            org_structure_org_ulid: orgStructureOrgULID,
            org_structure_job_ulid: orgStructureJobULID,
            ability_type: abilityType,
            edu_background: eduBackground,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setDataLists(data.dat || []);
                setPageCount(data.cnt || 0);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        }).always(() => setLoading(false))
    }, [messageApi, pageSize, currentIndex, triggerRefresh, status, displayname, phone, email, orgStructureOrgULID, orgStructureJobULID, abilityType, eduBackground]);


    /***
    * 导出 Excel
    */
    const exportAsExcel = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '员工信息-' + DateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '员工信息明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '姓名',
                    '电话',
                    '邮箱',
                    '身份证',
                    '性别',
                    '出生日期',
                    '年龄',
                    '能力类型',
                    '学历',
                    '部门',
                    '岗位',
                    '公司',
                    '住址',
                    '入职时间',
                    '员工编号',
                    '状态',
                    '备注'],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 获取导出明细
     */
    const exportGetData = () => {
        const params = {
            page_size: CNF.maxPageSize,
            current_index: 1,
            status,
            displayname,
            phone,
            email,
            org_structure_org_ulid: orgStructureOrgULID,
            org_structure_job_ulid: orgStructureJobULID,
            ability_type: abilityType,
            edu_background: eduBackground,
        }
        $.ajax({
            url: `${CNF.api}users/infos${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        // 删除非必须字段
                        var d = [];
                        for (let i = 0; i < data.dat.length; i++) {
                            var item = data.dat[i]
                            delete item['key'];
                            delete item['uid'];
                            delete item['username'];
                            delete item['surname'];
                            delete item['name'];
                            delete item['org_info_ulid'];
                            delete item['org_structure_org_ulid'];
                            delete item['org_structure_job_ulid'];
                            delete item['leave_date'];
                            delete item['create_username'];
                            delete item['create_displayname'];
                            delete item['create_time'];
                            delete item['update_time'];
                            d.push(item);
                        }
                        exportAsExcel(d);
                    } else {
                        exportAsExcel([]);
                    }
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    const hasExport = btnLists.includes(MODULENAME_PTN + '_export');

    return (
        <>
            {contextHolder}
            <Space style={{ padding: CNF.searchMarginLeft * 4 }}>
                {orgInfosLists && orgInfosLists.length > 1 &&
                    <Select
                        value={orgInfoULID || undefined}
                        style={{ width: '100%' }}
                        onChange={handleOrgInfoULIDChange}
                        placeholder="请选择"
                        allowClear={orgInfosLists.length > 1}
                        options={[
                            ...(orgInfosLists.length > 1 ? [{ value: '', label: '请选择' }] : []),
                            ...orgInfosLists.map(item => ({
                                value: item.key,
                                label: item.name,
                                key: item.key,
                            }))
                        ]}
                    />
                }
                <Input
                    onChange={handleDisplaynameChange}
                    placeholder='姓名'
                    value={displayname}
                />
                <Input
                    onChange={handlePhoneChange}
                    placeholder='电话'
                    value={phone}
                />
                <Input
                    onChange={handleEmailChange}
                    placeholder='邮箱'
                    value={email}
                />
                <Select
                    allowClear
                    placeholder='部门'
                    style={{ width: '100%' }}
                    onChange={handleOrgStructureOrgULIDChange}
                    value={orgStructureOrgULID || undefined}
                    popupMatchSelectWidth={false}
                    options={
                        orgStructuresLists
                            ?.filter(item => parseInt(item['org_function_type']) !== parseInt(CNF.orgFunctionTypes[2].value))
                            .map(item => ({
                                key: item.key,
                                value: item.key,
                                label: item.title,
                                sid: item.sid,
                            })) ?? []
                    }
                />
                <Select
                    allowClear
                    placeholder='岗位'
                    style={{ width: '100%' }}
                    onChange={handleOrgStructureJobULIDChange}
                    value={orgStructureJobULID || undefined}  // 请根据实际状态变量名调整
                    popupMatchSelectWidth={false}
                    options={
                        orgStructuresLists
                            ?.filter(item => {
                                // 只保留岗位类
                                if (parseInt(item['org_function_type']) !== parseInt(CNF.orgFunctionTypes[2].value)) {
                                    return false;
                                }

                                // 如果选择了部门，则只展示对应部门的岗位
                                if (sid) {
                                    return sid === item['up_sid'];
                                }

                                // 否则则全部保留
                                return true;
                            })
                            .map(item => ({
                                key: item.key,
                                value: item.key,
                                label: item.title
                            })) ?? []
                    }
                />
                <Select
                    allowClear
                    placeholder='能力类型'
                    style={{ width: '100%' }}
                    onChange={handleAbilityTypeChange}
                    value={abilityType || undefined}
                    popupMatchSelectWidth={false}
                    options={
                        CNF.abilityTypes?.map(item => ({
                            key: item.value,
                            value: item.value,
                            label: item.key
                        })) ?? []
                    }
                />
                <Select
                    allowClear
                    placeholder='学历'
                    style={{ width: '100%' }}
                    onChange={handleEduBackgroundChange}
                    value={eduBackground || undefined}
                    popupMatchSelectWidth={false}
                    options={
                        CNF.eduBackgrounds?.map(item => ({
                            key: item.value,
                            value: item.value,
                            label: item.key
                        })) ?? []
                    }
                />
                <Select
                    allowClear
                    placeholder='状态'
                    style={{ width: '100%' }}
                    onChange={handleStatusChange}
                    value={status || undefined}
                    popupMatchSelectWidth={false}
                    options={CNF.status.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.label
                    }))}
                />
                {hasExport && (
                    <Button
                        title={CNF.actionName.EXPORT + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<ExportOutlined />}
                        onClick={() => {
                            exportGetData();
                        }}>
                        {CNF.actionName.EXPORT}
                    </Button>
                )}
            </Space>
            <Lists
                btnLists={btnLists}
                preGroup={preGroup}
                dataLists={dataLists}
                currentIndex={currentIndex}
                pageCount={pageCount}
                changeIndex={changeIndex}
                setOpen={setOpenModal}
                refresh={refresh}
                loading={loading}
            />
            <Entity
                preGroup={preGroup}
                btnLists={btnLists}
                open={open}
                record={record}
                setOpen={setOpenModal}
                refresh={refresh}
                orgInfoULID={orgInfoULID}
                orgInfosLists={orgInfosLists}
                orgStructuresLists={orgStructuresLists}
            />
        </>
    );
}

export default UserInfo